import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const createPdf = (exportedPageId, pdfFileName) => {
  const exportedPageHtml = document.getElementById(exportedPageId);
  const footerText =
    "This job is fulfilled through Hiring Hub platform. For more information please visit www.hiring-hub.com.";

  html2canvas(exportedPageHtml, {
    logging: false,
  }).then((canvas) => {
    // eslint-disable-next-line new-cap
    const pdf = new jsPDF("p", "mm", "a4");
    const ctx = canvas.getContext("2d");
    const a4width = 200;
    const a4height = 267.5;
    const imgHeight = Math.floor((a4height * canvas.width) / a4width);
    let renderedHeight = 0;

    while (renderedHeight < canvas.height) {
      const page = document.createElement("canvas");

      page.width = canvas.width;
      page.height = Math.min(imgHeight, canvas.height - renderedHeight);

      page
        .getContext("2d")
        .putImageData(
          ctx.getImageData(
            0,
            renderedHeight,
            canvas.width,
            Math.min(imgHeight, canvas.height - renderedHeight)
          ),
          0,
          0
        );

      pdf.addImage(
        page.toDataURL("image/jpeg", 1.0),
        "JPEG",
        5,
        10,
        a4width,
        Math.min(a4height, (a4width * page.height) / page.width)
      );

      pdf.setFillColor(242, 0, 140);
      pdf.rect(0, 283, 220, 15, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(10).text(footerText, 25, 291);

      renderedHeight += imgHeight;
      if (renderedHeight < canvas.height) pdf.addPage();
    }

    pdf.save(pdfFileName);
  });
};

export { createPdf as default };
